<template>
    <div>

        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader class="p-1">
                        <CRow>
                            <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">
                                <strong>{{$t('list')}}</strong>

                            </CCol>
                            <CCol col="4" style="text-align: end">
                                <CButton
                                        class="mr-1"
                                        size="sm"
                                        color="secondary"
                                        @click="print_data"
                                >{{ $t("buttons.print") }}
                                </CButton>
                                <a href="/dashboard/users/add-user" target="_blank">
                                    <CButton
                                            class="mr-1"
                                            size="sm"
                                            color="dark"
                                    >
                                        <CIcon size="sm" name="cil-plus"></CIcon>
                                    </CButton>
                                </a>
                            </CCol>
                        </CRow>
                        <!--        </div>-->

                        <!-- Right aligned nav items -->
                        <!--      </CCollapse>-->
                    </CCardHeader>

                    <CCardBody>

<!--                        <CRow>-->
<!--                            <CCol col="3">-->
<!--                                <CSelect label="نوع"-->
<!--                                         horizontal-->
<!--                                         :options="reminder_types"-->
<!--                                         :value.sync="ReminderType"-->
<!--                                />-->
<!--                            </CCol>-->

<!--                        </CRow>-->
                        <CDataTable
                                :items="items_filtered"
                                :fields="fields"
                                column-filter
                                @row-clicked="table_row_clicked"
                                :items-per-page="10"
                                hover
                                striped
                                border
                                sorter
                                pagination
                        >
                            <template #row_id="{item,index}">

                                <td >
                                    <p >{{ index + 1 }}</p>

                                </td>

                            </template>


                            <template #startDate="{item,index}">
                                <td>
                                    <p >{{ get_date(item.startDate) }}</p>

                                </td>
                            </template>

                            <template #alarmDate="{item,index}">
                                <td>
                                    <p >{{ get_date(item.alarmDate) }}</p>
                                </td>
                            </template>

                            <template #priorityTitle="{item,index}">
                                <td :class="get_style(item)">
                                      <label >{{ item.priorityTitle }}</label>
                                </td>
                            </template>


                            <template #operation="{item,index}">
                                <td class="py-2">
                                    <CButton
                                            class="m-1"
                                            color="primary"
                                            variant="outline"
                                            square
                                            :title="$t('buttons.edit')"

                                            size="sm"
                                            @click="goEditPerson(item)"
                                    >
                                        <CIcon name="cil-pencil"/>
                                    </CButton>

                                </td>
                            </template>


                        </CDataTable>


                    </CCardBody>

                </CCard>
            </CCol>
        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';

    var items_data = [];


    export default {
        name: 'Login',
        data() {
            return {
                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                name: '',
                file: '',
                color: '#ffffff',
                previewImage: '',
                selected_template: 0,
                description: '',
                saleMethodModal: false,
                method_list: [],
                selected_method: '',
                selected_exist: 0,
                selected_person: 0,
                selected_status: 0,
                items_customer: [],
                fields: [
                    {key: 'row_id', label: this.$t('tables.row'),sorter:false, _style: 'width:5%'},
                  {key: 'startDate', label: this.$t('date'), _style: 'width:10%'},
                  {key: 'startTime', label: this.$t('time'), _style: 'width:10%'},

                  {key: 'categoryTitle', label: this.$t('tables.category'), _style: 'width:10%'},
                    // {key: 'reminderTypeTitle', label: "نوع", _style: 'width:10%'},
                    {key: 'priorityTitle', label: this.$t('priority'), _style: 'width:10%'},
                  {key: 'statusTitle', label:this.$t('tables.status'), _style: 'width:10%'},

                    {key: 'title', label: this.$t('title'), _style: 'width:10%'},
                   // {key: 'alarmDate', label: "تاریخ آلارم", _style: 'width:10%'},
                   //  {key: 'contactName', label: "مخاطب", _style: 'width:10%'},
                ],
                // alarmDate: "2021-07-08T00:00:00"
                // categoryId: 4
                // id: 1
                // note: "خرید سرور"
                // personId: 11
                // priorityId: 54
                // priorityTitle: ""
                // reminderType: 77
                // reminderTypeTitle: ""
                // startDate: "2021-06-30T00:00:00"
                // startTime: "13:08"
                // statusId: 39
                // statusTitle: ""
                items_filtered: [],
                items_original: [],
                // fields,

                // fields,

                details: [],

                collapseDuration: 0,
                status_form: 0,
                table_clicks: 0,
              ReminderType: 0,
              reminder_types: [],
                table_clicks_timer: null,
            }
        },
      beforeDestroy() {
        console.log("before desroy called")
        bus.$off()
      },
      mounted() {
            this.get_lists()
            this.get_sys()

            this.$root.root_validate_errors = [];
            bus.$on('update_reminder', (data) => {
                this.get_lists()
            });
            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        }, watch: {
            'selected_status': function () {
                this.get_lists();
            },
            'ReminderType': function () {
                this.filter_data();
            }
        },
        methods: {
          get_style(item){
            if(item.priorityTitle=="بالا"){
              return "bg-warning";
            }
          },
          filter_data(){
            if(this.ReminderType==0){
              this.items_filtered = this.items_original;
            }else{
              this.items_filtered = this.items_original.filter(x=>x.reminderType == this.ReminderType)
            }
          },
            table_row_clicked(item, index) {

                this.table_clicks++;
                if (this.table_clicks == 1) {
                    this.table_clicks_timer = setTimeout(() => {
                        // this.result.push(event.type);
                        this.table_clicks = 0
                    }, 500);
                } else if (this.table_clicks > 1) {
                    clearTimeout(this.table_clicks_timer);
                    // this.goEditPerson(item)

                }

            },
          get_sys() {
            var self = this;

            const formData = new FormData();

            axios.post('GetSysPersonGlobals', formData, {}).then(function (response) {

              var content_data = response.data;

              // items = content_cats.orders;
              self.reminder_types = [{label:self.$t('all'),value:0}];


              content_data.forEach((val) => {
                var obj = {label: val.title, value: val.id}

                if (val.titleType == 23) {
                  self.reminder_types.push(obj);
                }

              });
              self.ReminderType = self.reminder_types[0].value

            })
                    .catch(function (error) {
                      console.log(error);
                    });

          },


            get_lists() {
                var self = this;


                const formData = new FormData();

                var url = "GetUserReminderList";

                formData.append('Id', 0);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.items_filtered = content_data.data;
                        self.items_original = content_data.data;

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            goEditPerson(item) {

                this.$router.push({path: '/dashboard/users/edit-user/' + item.userId});

            },

            delete_item_dialog(item) {
                this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

                this.status_form = this.items[item.row_id].id;

            },
            delete_item() {


                let self = this;
                const formData = new FormData()
                let url;
                url = "DeletePerson";


                formData.append('id', this.status_form);

                axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res);

                    self.status_form = 0;

                    self.get_lists();

                })
                    .catch(function (error) {

                        console.log(error);
                    });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
        }
    }

</script>
